export default __webpack_public_path__ + "static/media/pass.bc024115.svg";